export const MAX_MEDIA_FILES = 5;

export const MAX_POST_CHARS = 4000;

export const ACCEPTED_MEDIA_TYPES = [
  'image/jpeg',
  'image/png',
  'video/mp4',
  'video/quicktime',
] as const;
